import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../../shared-styles/flex';

export const StatusIndicatorContainer = styled.div`
  ${FlexNoAlign}
  gap: 3.5px; 
`;
